import React from 'react'
import {makeStyles} from '@material-ui/core/styles'
import {Box, Drawer, IconButton, Typography} from '@material-ui/core'
import Close from '@material-ui/icons/Close'
import CreateSuperAdmin from './SuperAdminRolesDrawer/CreateSuperAdmin'
import NotFound from '../../../NotFound'

const useStyles = makeStyles(theme => ({
    drawerContainer: {
        width: '400px',
        padding: '20px',
    },
    titleBox: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
    },
    boundaryBox: {
        margin: '15px 0',
    },
    submitButton: {
        color: theme.palette.common.white,
        backgroundColor: theme.palette.primary.main,
        margin: theme.spacing(1, 0),
        boxShadow: 'none',
        borderRadius: theme.shape.borderRadius,
        height: '2.625rem',
        textTransform: 'uppercase',
        width: '100%',
        '&:hover': {
            boxShadow: 'none',
            backgroundColor: '#00652A',
        },
    },
    lookupButton: {
        margin: theme.spacing(1, 0),
        boxShadow: 'none',
        borderRadius: theme.shape.borderRadius,
        border: '1px solid #098447',
        color: theme.palette.primary.main,
        height: '2.625rem',
        textTransform: 'uppercase',
        width: '100%',
    },
}))

export default function SuperAdminRoleDrawer(props) {
    const classes = useStyles()
    const {
        title,
        openDialog,
        handleCloseDialog,
        handleToggleStatus,
        currentsuperadmin,
    } = props

    let component = null
    switch (title) {
        case 'Create Super Admin':
            component = (
                <CreateSuperAdmin
                    superadmin={currentsuperadmin}
                    handleCloseDialog={handleCloseDialog}
                    handleToggleStatus={handleToggleStatus}
                />
            )
            break
        default:
            component = <NotFound />
    }
    return (
        <>
            <Drawer
                anchor={'right'}
                open={openDialog}
                onClose={handleCloseDialog}
            >
                <Box className={classes.drawerContainer}>
                    <Box className={classes.titleBox}>
                        <Typography
                            variant="h5"
                            style={{alignSelf: 'center', color: '#000000'}}
                        >
                            {title}
                        </Typography>
                        <IconButton onClick={handleCloseDialog}>
                            <Close style={{color: '#000000'}} />
                        </IconButton>
                    </Box>

                    {component}
                </Box>
            </Drawer>
        </>
    )
}
